<aside
  *ngIf="selectedApp !== null"
  (window:resize)="onResizeAction()"
  class="left-sidebar"
  data-sidebarbg="skin6"
  [ngClass]="{
    clsExpandSidebar: isTabletOrPhone ? !isExpandedSidebar : !isMouseHovering
  }"
>
  <div
    class="ps-container ps-theme-default main-sections-div"
    data-ps-id="610c625b-d483-653c-dc1d-14aec1d11559"
    (mouseover)="onMouseHover()"
    (mouseout)="onMouseLeave()"
    onfocus="onmouseover"
    onblur="onmouseout"
  >
    <nav
      class="sidebar-nav"
      [ngClass]="{
        'sidebar-nav-small': !isMouseHovering && !isExpandedSidebar
      }"
      style="height: 100%"
    >
      <ul id="sidebarnav" *ngIf="selectedSection">
        <div class="header-section">
          <li class="sidebar-item">
            <a
              class="sidebar-link clsLogoA"
              (click)="toggleOption(globals.DASHBOARD)"
            >
              <img
                [src]="
                  !isTabletOrPhone && !isMouseHovering
                    ? '../../../assets/images/light-house-icon.svg'
                    : isMouseHovering || isExpandedSidebar
                    ? '../../../assets/images/lighthouse-logo.svg'
                    : '../../../assets/images/light_house_logo_tablet.png'
                "
                class="clsLogoLH"
                [ngClass]="{ hoverImage: isMouseHovering }"
                alt=""
                width=""
                height=""
              />
            </a>
          </li>
          <li class="sidebar-item" id="leftDropDown">
            <div class="user-profile d-flex no-block dropdown">
              <div
                class="user-content clsCombo clsMenuApps clsCursorPointer"
                (click)="dropdownChange()"
                (keydown)="dropdownChange()"
              >
                <div
                  class="user-content hide-menu clsCombo clsComboProductos show"
                >
                  <a
                    #dropdownElement
                    class="clsComboItemActive"
                    id="CmbProductos"
                    role="button"
                    data-toggle="dropdown"
                  >
                    <h5
                      class="mb-0 user-name font-medium ComboItemActive_Active"
                    >
                      <img
                        [src]="
                          selectedApp.icon === null
                            ? '../../../assets/images/icons/app_process.svg'
                            : selectedApp.icon
                        "
                        alt="users"
                        class="clsImageApp flag-icon"
                        width="40"
                      />
                      <span
                        *ngIf="isMouseHovering || isExpandedSidebar"
                        class="clsImageApp_Span clsCmbElipsis"
                        >{{ selectedApp.name }}</span
                      >
                      <img
                        *ngIf="isMouseHovering || isExpandedSidebar"
                        class="clsComboArrowDropDown"
                        src="../../../assets/images/icons/arrow-dropdown.svg"
                        width="10px"
                        style="
                          float: right;
                          padding-top: 12px;
                          margin-left: 8px;
                          margin-right: 20px;
                        "
                        alt=""
                        width=""
                        height=""
                      />
                      <img
                        class="clsItemTechnology"
                        [src]="
                          selectedApp.tech === this.globals.tech_Android
                            ? '../../../assets/images/android.png'
                            : '../../../assets/images/ios.png'
                        "
                        alt=""
                        width=""
                        height=""
                      />
                    </h5>
                  </a>
                  <div
                    #dropdownElement
                    *ngIf="dropDownOpen"
                    class="dropdown-menu clsDivApps"
                  >
                    <input
                      type="text"
                      class="dropdown-item clsItemApp clsSearchApps"
                      (keyup)="refreshAppList($event.target.value)"
                    />
                    <div [ngClass]="{ clsDivAppsScroll: appsUser.length > 5 }">
                      <a
                        class="dropdown-item clsItemApp"
                        *ngFor="let app of appsUser"
                        (click)="onSelectionChange(app)"
                      >
                        <img
                          [src]="
                            app.icon === null
                              ? '../../../assets/images/icons/app_process.svg'
                              : app.icon
                          "
                          alt="users"
                          class="clsImageApp"
                          width="40"
                        />
                        <span
                          [attr.test-id]="generateTestId(app)"
                          class="clsImageApp_Span clsCmbElipsis"
                          >{{ app.name }}
                        </span>
                        <img
                          [class]="{
                            clsItemTechnology: !isIEOrEdge,
                            clsItemTechnologyIE: isIEOrEdge
                          }"
                          [src]="
                            app.tech === this.globals.tech_Android
                              ? '../../../assets/images/android.png'
                              : '../../../assets/images/ios.png'
                          "
                          alt=""
                          width=""
                          height=""
                        />
                      </a>
                      <a
                        *ngIf="!userInfo.is_tour && userInfo.can_onboard"
                        class="dropdown-item clsItemApp"
                        (click)="onSelectionChange(register)"
                      >
                        <img
                          src="{{ register.icon }}"
                          alt="users"
                          class="clsImageApp"
                          width="40"
                        />
                        <span class="clsImageApp_Span clsCmbElipsis">{{
                          register.name
                        }}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li class="sidebar-item">
            <hr
              [ngClass]="{
                clsSeparatorHR:
                  (!isTabletOrPhone && isMouseHovering) ||
                  (isTabletOrPhone && isExpandedSidebar === true),
                'clsSeparatorHR-small':
                  (!isTabletOrPhone && !isMouseHovering) ||
                  (isTabletOrPhone && isExpandedSidebar === false)
              }"
            />
          </li>

          <li
            class="sidebar-item notification-bell"
            *ngIf="
              isNotificationsBellVisible() &&
              this.router.url !== '/readytostart' &&
              this.router.url !== '/onboarding'
            "
          >
            <app-notification-bell></app-notification-bell>
          </li>

          <li class="sidebar-item chatbot">
            <a
              class="sidebar-link clsCursorPointer"
              aria-expanded="false"
              (click)="chatbotOpen()"
            >
              <img
                [src]="'../../../assets/images/icons/engage.png'"
                alt=""
                width="30"
                height="30"
              />
              <span class="hide-menu">{{
                'component.leftNavBar.chatbot-section' | translate
              }}</span>
            </a>
          </li>

          <li class="sidebar-item">
            <hr
              [ngClass]="{
                clsBigSeparatorHR:
                  (!isTabletOrPhone && isMouseHovering) ||
                  (isTabletOrPhone && isExpandedSidebar === true),
                'clsSeparatorHR-small':
                  (!isTabletOrPhone && !isMouseHovering) ||
                  (isTabletOrPhone && isExpandedSidebar === false)
              }"
            />
          </li>
        </div>

        <div class="main-menu-sections">
          <li
            *ngIf="visibleSection(globals.DASHBOARD)"
            [attr.section]="globals.DASHBOARD"
            class="sidebar-item"
          >
            <a
              [ngClass]="{
                clsMenuSelect: selectedSection.code === globals.DASHBOARD,
                clsMenuOptionSelected:
                  selectedSection.code === globals.DASHBOARD
              }"
              (click)="toggleOption(globals.DASHBOARD)"
              class="sidebar-link clsCursorPointer clsMenuOption clsOpenDiv"
              aria-expanded="false"
            >
              <i
                class="mnu mnu-dashboard"
                [ngClass]="{
                  'mnu-small': isTabletOrPhone && isExpandedSidebar === false
                }"
              ></i>
              <span class="hide-menu">{{
                'component.leftNavBar.dashboard-section' | translate
              }}</span>
            </a>
          </li>
          <li
            *ngIf="visibleSection(globals.CONFIGURE)"
            [attr.section]="globals.CONFIGURE"
            class="sidebar-item"
          >
            <a
              [ngClass]="{
                clsMenuSelect: selectedSection.code === globals.CONFIGURE,
                clsMenuOptionSelected:
                  selectedSection.code === globals.CONFIGURE
              }"
              class="sidebar-link clsCursorPointer clsMenuOption clsOpenDiv"
              (click)="toggleOption(globals.CONFIGURE)"
              aria-expanded="false"
            >
              <i
                class="mnu mnu-configure"
                [ngClass]="{
                  'mnu-small': isTabletOrPhone && isExpandedSidebar === false
                }"
              ></i>
              <span class="hide-menu">{{
                'component.leftNavBar.configure-section' | translate
              }}</span>
            </a>
          </li>
          <li
            *ngIf="visibleSection(globals.USERMANAGEMENT)"
            [attr.section]="globals.USERMANAGEMENT"
            class="sidebar-item"
          >
            <a
              [ngClass]="{
                clsMenuSelect: selectedSection.code === globals.USERMANAGEMENT,
                clsMenuOptionSelected:
                  selectedSection.code === globals.USERMANAGEMENT
              }"
              class="sidebar-link clsCursorPointer clsMenuOption clsOpenDiv"
              (click)="toggleOption(globals.USERMANAGEMENT)"
              aria-expanded="false"
            >
              <i
                class="mnu mnu-user-management"
                [ngClass]="{
                  'mnu-small': isTabletOrPhone && isExpandedSidebar === false
                }"
              ></i>
              <span class="hide-menu">{{
                'component.leftNavBar.user-management-section' | translate
              }}</span>
            </a>
          </li>
          <li
            *ngIf="visibleSection(globals.DEVELOP)"
            [attr.section]="globals.DEVELOP"
            class="sidebar-item"
          >
            <a
              [ngClass]="{
                clsMenuSelect: selectedSection.code === globals.DEVELOP,
                clsMenuOptionSelected: selectedSection.code === globals.DEVELOP
              }"
              class="sidebar-link clsCursorPointer clsMenuOption clsOpenDiv clsMenuOption"
              (click)="toggleOption(globals.DEVELOP)"
              aria-expanded="false"
            >
              <i
                class="mnu mnu-develop"
                [ngClass]="{
                  'mnu-small': isTabletOrPhone && isExpandedSidebar === false
                }"
              ></i>
              <span class="hide-menu">{{
                'component.leftNavBar.develop-section' | translate
              }}</span>
            </a>
          </li>
          <li
            *ngIf="visibleSection(globals.APPDISTRIBUTION)"
            [attr.section]="globals.APPDISTRIBUTION"
            class="sidebar-item"
          >
            <a
              [ngClass]="{
                clsMenuSelect: selectedSection.code === globals.APPDISTRIBUTION,
                clsMenuOptionSelected:
                  selectedSection.code === globals.APPDISTRIBUTION
              }"
              class="sidebar-link clsCursorPointer clsMenuOption clsOpenDiv"
              (click)="toggleOption(globals.APPDISTRIBUTION)"
              aria-expanded="false"
            >
              <i
                class="mnu mnu-app-distribution"
                [ngClass]="{
                  'mnu-small': isTabletOrPhone && isExpandedSidebar === false
                }"
              ></i>
              <span class="hide-menu">
                {{
                  'component.leftNavBar.app-distribution-section' | translate
                }}</span
              >
            </a>
          </li>
          <li
            *ngIf="globals.enableAutomationTesting"
            [attr.section]="globals.TESTING"
            class="sidebar-item"
          >
            <a
              [ngClass]="{
                clsMenuSelect: selectedSection.code === globals.TESTING,
                clsMenuOptionSelected: selectedSection.code === globals.TESTING
              }"
              class="sidebar-link clsCursorPointer clsMenuOption clsOpenDiv"
              (click)="toggleOption(globals.TESTING)"
              aria-expanded="false"
            >
              <i
                class="mnu mnu-automation-testing"
                [ngClass]="{
                  'mnu-small': isTabletOrPhone && isExpandedSidebar === false
                }"
              ></i>
              <span class="hide-menu">{{
                'component.leftNavBar.automation-testing-section' | translate
              }}</span>
            </a>
          </li>
          <li
            *ngIf="visibleSection(globals.SECURITY)"
            [attr.section]="globals.SECURITY"
            class="sidebar-item"
          >
            <a
              [ngClass]="{
                clsMenuSelect: selectedSection.code === globals.SECURITY,
                clsMenuOptionSelected: selectedSection.code === globals.SECURITY
              }"
              class="sidebar-link clsCursorPointer clsMenuOption clsOpenDiv"
              (click)="toggleOption(globals.SECURITY)"
              aria-expanded="false"
            >
              <i
                class="mnu mnu-security-assessment"
                [ngClass]="{
                  'mnu-small': isTabletOrPhone && isExpandedSidebar === false
                }"
              ></i>
              <span class="hide-menu">{{
                'component.leftNavBar.security-section' | translate
              }}</span>
            </a>
          </li>
          <li
            *ngIf="visibleSection(globals.PUBLISH)"
            [attr.section]="globals.PUBLISH"
            class="sidebar-item"
          >
            <a
              [ngClass]="{
                clsMenuSelect: selectedSection.code === globals.PUBLISH,
                clsMenuOptionSelected: selectedSection.code === globals.PUBLISH
              }"
              class="sidebar-link clsCursorPointer clsMenuOption clsOpenDiv"
              (click)="toggleOption(globals.PUBLISH)"
              aria-expanded="false"
            >
              <i
                class="mnu mnu-publish"
                [ngClass]="{
                  'mnu-small': isTabletOrPhone && isExpandedSidebar === false
                }"
              ></i>
              <span class="hide-menu">{{
                'component.leftNavBar.publish-section' | translate
              }}</span>
            </a>
          </li>
          <li
            *ngIf="visibleSection(globals.ENGAGE)"
            [attr.section]="globals.ENGAGE"
            class="sidebar-item"
          >
            <a
              [ngClass]="{
                clsMenuSelect: selectedSection.code === globals.ENGAGE,
                clsMenuOptionSelected: selectedSection.code === globals.ENGAGE
              }"
              class="sidebar-link clsCursorPointer clsMenuOption"
              (click)="toggleOption(globals.ENGAGE)"
              aria-expanded="false"
            >
              <i
                class="mnu mnu-engage"
                [ngClass]="{
                  'mnu-small': isTabletOrPhone && isExpandedSidebar === false
                }"
              ></i>
              <span class="hide-menu">{{
                'component.leftNavBar.engage-section' | translate
              }}</span>
            </a>
          </li>
          <li
            *ngIf="
              visibleSection(globals.MEASURE) &&
              !visibleSection(globals.MEASURE_NAP)
            "
            [attr.section]="globals.MEASURE"
            rmifnotlive="true"
            class="sidebar-item"
          >
            <a
              [ngClass]="{
                clsMenuSelect: selectedSection.code === globals.MEASURE,
                clsMenuOptionSelected: selectedSection.code === globals.MEASURE
              }"
              class="sidebar-link clsCursorPointer clsMenuOption measure-link"
              (click)="loadUrlMeasure()"
              aria-expanded="false"
            >
              <i
                class="mnu mnu-measure-learn"
                [ngClass]="{
                  'mnu-small': isTabletOrPhone && isExpandedSidebar === false
                }"
              ></i>
              <span class="hide-menu">{{
                'component.leftNavBar.measure-learn-section' | translate
              }}</span>
              <i class="clsLinkExt"></i>
            </a>
          </li>
          <li
            *ngIf="visibleSection(globals.MEASURE_NAP)"
            [attr.section]="globals.MEASURE_NAP"
            class="sidebar-item"
          >
            <a
              [ngClass]="{
                clsMenuSelect: selectedSection.code === globals.MEASURE_NAP,
                clsMenuOptionSelected:
                  selectedSection.code === globals.MEASURE_NAP
              }"
              class="sidebar-link clsCursorPointer clsMenuOption"
              (click)="toggleOption(globals.MEASURE_NAP)"
              aria-expanded="false"
            >
              <i
                class="mnu mnu-measure-learn"
                [ngClass]="{
                  'mnu-small': isTabletOrPhone && isExpandedSidebar === false
                }"
              >
              </i>
              <span class="hide-menu">{{
                'component.leftNavBar.measure-learn-section' | translate
              }}</span>
            </a>
          </li>
        </div>

        <div class="footer-section">
          <li class="sidebar-item">
            <hr
              [ngClass]="{
                clsBigSeparatorHR:
                  (!isTabletOrPhone && isMouseHovering) ||
                  (isTabletOrPhone && isExpandedSidebar === true),
                'clsSeparatorHR-small':
                  (!isTabletOrPhone && !isMouseHovering) ||
                  (isTabletOrPhone && isExpandedSidebar === false)
              }"
            />
          </li>
          <li *ngIf="isTabletOrPhone" class="sidebar-item">
            <a
              class="sidebar-link clsCursorPointer clsMenuOption"
              (click)="toggleMenu()"
            >
              <i
                class="mnu"
                [ngClass]="{
                  mnuCollapse: isExpandedSidebar,
                  mnuExpand: !isExpandedSidebar
                }"
              ></i>
              <span class="hide-menu collapse-button">{{
                'component.leftNavBar.collapse-sidebar-section' | translate
              }}</span>
            </a>
          </li>
          <li class="sidebar-item">
            <a
              class="sidebar-link clsCursorPointer clsMenuOption"
              (click)="openHelpInfo()"
            >
              <i class="mnu mnu-help"></i>
              <span class="hide-menu help-button">{{
                'component.leftNavBar.help-section' | translate
              }}</span>
            </a>
          </li>
          <li
            class="sidebar-item clsUtilsItem"
            [ngClass]="{ clsMarginBottom100px: userInfo.is_tour }"
          >
            <a
              class="sidebar-link clsCursorPointer clsMenuOption"
              (click)="onClickSignOut()"
            >
              <i class="mnu mnu-sign-out"></i>
              <span class="hide-menu">{{ 'common.sign-out' | translate }}</span>
            </a>
          </li>
        </div>
      </ul>
    </nav>
  </div>
</aside>
